<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title"> {{datToChild.mode}} - Master </p>
<!--                <p class="modal-card-title"> {{datToChild.name}}</p>-->
<!--                <p class="modal-card-title"> {{datToChild.enable}}</p>-->
                <button class="delete" aria-label="close"   @click="close" ></button>
            </header>

            <section class="modal-card-body">
                <!--                  content-->
                <b-loading  :active.sync="isFullScreenLoading" />
                <b-field label="Name">
                    <b-input  v-model="datToChild.name" />
                </b-field>

                <b-field label="Name" v-if="datToChild.mode === 'Edit' ">
                    <b-switch v-model="datToChild.enable">
                        {{ datToChild.enable }}
                    </b-switch>
                </b-field>



            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="close" >Cancel</b-button>
                &nbsp;&nbsp;&nbsp;
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveData" >Save</b-button>

            </footer>
        </div>
    </div>
</template>

<script>
    // import moment from "moment";
    import axios from "axios";
    import {getConfigAxios , getBaseURLforBackEnd  }  from '@/utils.js'
    import { mapState } from "vuex";


    export default {
        name: "AddEditSpecimensType",
        props:{
            datToChild : {}  //  {"mode" : "Add" , "id": null,"name": "","enable" : false}
                             //  "Add" , "Edit"
        },
        computed:{
             ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        data(){
            return {
                isFullScreenLoading : false
            }
        },
        methods:{
            closeWithEdit(){
                this.$emit('closeWithEdit')
            },
            closeWithSave(){
                this.$emit('closeWithAddNew')
            },
            close(){
              this.$emit('closeWithNothing')
            },
            saveData(){
                // class-out add or edit
               if( this.datToChild.mode === 'Add' ){
                   if(this.datToChild.name.length>0){
                       this.addData()
                   }else{
                       this.$buefy.dialog.alert({
                           title: 'Error',
                           message: 'pls enter some text to to save!!!',
                           type: 'is-danger',
                           hasIcon: true,
                           icon: 'times-circle',
                           iconPack: 'fa',
                           ariaRole: 'alertdialog',
                           ariaModal: true
                       })
                   }

               }else if( this.datToChild.mode === 'Edit' ){
                   if(this.datToChild.name.length>0){
                       this.editData()
                   }else{
                       this.$buefy.dialog.alert({
                           title: 'Error',
                           message: 'pls enter some text to to save!!!',
                           type: 'is-danger',
                           hasIcon: true,
                           icon: 'times-circle',
                           iconPack: 'fa',
                           ariaRole: 'alertdialog',
                           ariaModal: true
                       })
                   }

               }else{
                       this.$buefy.dialog.alert({
                           title: 'Error',
                           message: 'Something goes error, pls contact to admin',
                           type: 'is-danger',
                           hasIcon: true,
                           icon: 'times-circle',
                           iconPack: 'fa',
                           ariaRole: 'alertdialog',
                           ariaModal: true
                       })
                }

            },


            addData(){
                const datTo = {
                              "name": this.datToChild.name,
                       }

                const vm = this
                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/addspecimentype`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$buefy.toast.open({
                                message: `Success to save`,
                                type: 'is-success'
                            })
                            vm.isFullScreenLoading = false
                            vm.closeWithSave()
                        }
                    })
                    .catch((err)=>{
                        vm.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            },


            editData(){
                const datTo = {
                    "id" : this.datToChild.id,
                    "name": this.datToChild.name,
                    "enable": this.datToChild.enable
                }

                const vm = this
                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/updatespecimentype`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$buefy.toast.open({
                                message: `Success to update`,
                                type: 'is-success'
                            })
                            vm.isFullScreenLoading = false
                            vm.closeWithEdit()
                        }
                    })
                    .catch((err)=>{
                        vm.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            }
        }
    }
</script>

<style scoped>

</style>